import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventorySuppliersBus } from '@app/cp/shared/models/InventorySuppliersBus';
import { VendorReturnDetailBus } from '@app/cp/shared/models/VendorReturnDetailBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { MessageType } from '@app/cp/shared/enums/MessageType';

@Component({
    selector: 'vendor-return-parts',
    templateUrl: './vendor-return-parts.component.html',
    styleUrls: ['./vendor-return-parts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VendorReturnPartsComponent extends BaseGridEditLineComponent<VendorReturnDetailBus, null, OrderService> {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "VendorReturnDetailBus";
    }

    @Input() defaultInventory: VendorReturnDetailBus[] = [];
    //@Input() defaultOrderId: any;

    createForm() {
        this.editForm = new UntypedFormGroup({
            'vendorReturnDetailId': new UntypedFormControl(),
            'vendorReturnId': new UntypedFormControl(),
            'orderId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'qtyToReturn': new UntypedFormControl(null),
            'inventoryId': new UntypedFormControl(),
            'inventoryLocationId': new UntypedFormControl(null),
            'isWarranty': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),

            'deductedQty': new UntypedFormControl(),
            'deductedDate': new UntypedFormControl(),
            'returnNote': new UntypedFormControl(),
            'number': new UntypedFormControl(),
            'inventoryDesc': new UntypedFormControl(),
            'dispatchNumber': new UntypedFormControl(),
            'orderNumber': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            vendorReturnDetailId: this.selectedData.vendorReturnDetailId,
            vendorReturnId: this.selectedData.vendorReturnId,
            orderId: this.selectedData.orderId,
            dispatchId: this.selectedData.dispatchId,
            qtyToReturn: this.selectedData.qtyToReturn,
            inventoryId: this.selectedData.inventoryId,
            inventoryLocationId: this.selectedData.inventoryLocationId,
            isWarranty: this.selectedData.isWarranty,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,

            deductedQty: this.selectedData.deductedQty,
            deductedDate: this.selectedData.deductedDate,
            returnNote: this.selectedData.returnNote,
            number: this.selectedData.number,
            inventoryDesc: this.selectedData.inventoryDesc,
            dispatchNumber: this.selectedData.dispatchNumber,
            orderNumber: this.selectedData.orderNumber
        });
    }
    dispatchSearch: boolean = false;

    invLocCBOChanged(e: any, editForm: UntypedFormGroup) {
        editForm.patchValue({
            inventoryLocationId: e ? e.value : null
        });
        this.setDirty();
        this.SetChanged();
    }

    qtyChanged(e: any) {
        this.setDirty();
        this.SetChanged();
    }

    /**
   * Validates that every line item with an Inventory # has both a Warehouse
   * (inventoryLocationId) and a Qty (qtyToReturn). Used by the parent to gate
   * the Save button. This checks committed rows as well as the row currently
   * being added/edited (e.g. populated via inventory search but not yet committed).
   */
    public areLineItemsValid(): boolean {
            let editingCid: any = this.hasEditForm ? this.editForm.value.vendorReturnDetailId : null;
            if (CommonFunctions.hasArrayValue(this.gridData)) {
                for (let item of this.gridData) {
                    if (CommonFunctions.hasValue(editingCid) && item.vendorReturnDetailId === editingCid) {
                        continue;
                    }
                    if (!this.isLineItemValid(item)) {
                        return false;
                    }
                }
            }
            if (this.hasEditForm && !this.isLineItemValid(this.editForm.value)) {
                return false;
            }
            return true;
    }

    private isLineItemValid(item: any): boolean {
        if (!CommonFunctions.hasValue(item)) {
            return true;
        }
        let hasInventory: boolean = CommonFunctions.hasGuidValue(item.inventoryId) || CommonFunctions.hasStringValue(item.number);
        if (!hasInventory) {
            return true;
        }
        return CommonFunctions.hasGuidValue(item.inventoryLocationId) && CommonFunctions.hasNumberValueIncludingZero(item.qtyToReturn);
    }

    /**
     * Commits the row that is currently in edit mode into gridData (keyed by CID)
     * so its latest warehouse/qty values are captured. The parent calls this
     * synchronously before reading the line items on Save, because the base grid
     * otherwise only commits an open editor on a delayed document-click handler
     * that races the Save click.
     */
    public commitOpenEditor(): void {
        if (this.hasEditForm && this.canSaveForm) {
            this.saveHandler();
        }
    }

    /**
     * When a not-yet-committed added row is deleted, the base flow removes it from
     * the grid data but leaves the edit form open with stale (invalid) values.
     * Close the editor so that lingering form is not counted as an invalid line item,
     * allowing the parent Save button to re-enable.
     */
    override deletedLocalNoId() {
        if (this.hasEditForm) {
            this.closeEditor();
        }
        this.sendParentMessage(MessageType.changed);
    }

    protected save(dataObj: VendorReturnDetailBus) {

    }
    costChange(event, dataItem, editForm) {

    }
    muChange(event, dataItem: OrderDetailsBus, editForm) {
        let mu = (event * 1) / 100;
    }
    public accountClass(id: string) {
        return this.referenceData.accountClasses.find(x => x.value === id);
    }
    partSuppliers: InventorySuppliersBus[];
    partSuppliersActive: boolean = false;
    partSuppliersHeight: number = 0;
    showInventorySuppliers(dataItem: OrderDetailsBus) {
        this.svc_inv.getInventorySuppliers(dataItem.inventoryId).subscribe((data: InventorySuppliersBus[]) => {
            if (CommonFunctions.hasArrayValue(data)) {
                if (data.length > 20) {
                    this.partSuppliersHeight = 600;
                }
                else {
                    this.partSuppliersHeight = 0;
                }
            }
            this.partSuppliers = data;
            this.partSuppliersActive = true;
        });
    }
    closePartSupplier() {
        this.partSuppliersActive = false;
    }

}
